import { useEffect, useState } from 'react'

/**
 * Глобальный стор «для какого ИСХОДНОГО трека сейчас генерится новая версия».
 * Продление/перепеть/+вокал/+музыка идут через виджет генерации (pin → «Создать»);
 * GenerateContext помечает sourceTrack на время isLoading. Список и кабинет
 * показывают лоадинг-пилюлю на ИСХОДНОМ треке во время генерации версии.
 * Без провайдера/контекста — модуль-стор + подписка (как describingStore).
 */
const ids = new Set<string>()
const listeners = new Set<() => void>()

export const genVersionStore = {
	start(id: string) { ids.add(id); listeners.forEach((l) => l()) },
	end(id: string) { ids.delete(id); listeners.forEach((l) => l()) },
	has(id: string) { return ids.has(id) },
	subscribe(l: () => void) { listeners.add(l); return () => { listeners.delete(l) } },
}

/** Генерится ли новая версия для этого трека — лоадинг-пилюля в списке (per-track). */
export function useIsGeneratingVersion(id: string): boolean {
	const [running, setRunning] = useState(() => genVersionStore.has(id))
	useEffect(() => {
		const update = () => setRunning(genVersionStore.has(id))
		update()
		return genVersionStore.subscribe(update)
	}, [id])
	return running
}

/** Множество исходных треков с генерящейся версией — для кабинета (проверка
 *  per-версия без хука-на-каждую-версию: один хук, .has(v.id) в рендере). */
export function useGeneratingVersionSet(): ReadonlySet<string> {
	const [snap, setSnap] = useState<ReadonlySet<string>>(() => new Set(ids))
	useEffect(() => genVersionStore.subscribe(() => setSnap(new Set(ids))), [])
	return snap
}
